export default __webpack_public_path__ + "static/media/ipadBanner.eeee37a7.webp";